import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Desplaza a la sección indicada en el hash al cargar o cambiar la URL (one-page).
 */
export default function ScrollToHash() {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (pathname !== '/' || !hash) return;
    const id = hash.replace('#', '');
    if (!id) return;

    const scrollToTarget = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    const t = window.setTimeout(scrollToTarget, 80);
    return () => window.clearTimeout(t);
  }, [hash, pathname]);

  return null;
}
